import { Product } from '@core/models/piramide/Product';

export class Monitor extends Product {
  $caracteristicas: {
    ConsumoMax: number;
    DP: number;
    DVI: number;
    HDMI: number;
    USB20: number;
    USB30: number;
    USB31: number;
    VESA: string;
    VGA: number;
    alto: number;
    amd_freesync: number;
    ancho: number;
    android_tv: number;
    angulo_vision_horizontal: number;
    angulo_vision_vertical: number;
    brillo: number;
    cables: string;
    cant_parlantes: number;
    cantidad: number;
    colores: number;
    control_remoto: number;
    curvatura: number;
    curvo: number;
    display_wifi: number;
    entra_3_5mm: number;
    entrada_3_5_mic: number;
    espesor: number;
    fecha_update: string;
    id_producto: number;
    max_frecuenta: number;
    mini_dp: number;
    nvidia_g_sync: number;
    peso: number;
    pie_desmontable: number;
    potencia_x_parlante: null;
    pulgadas: number;
    pulgadas_visibles: number;
    radio_constraste_dynamico: number;
    radio_constraste_estativo: number;
    resolucion: string;
    salida_3_5mm: number;
    sintonizador_analogico: number;
    sintonizador_tda: number;
    smart: number;
    tactil: number;
    tiempo_respuesta: number;
    tipo_de_iluminacion: string;
    tipo_de_panel: string;
    tipo_fuente: string;
    tres_d: string;
    vida_backlight: number;
  };
}
